// 应用状态
export const statusOptions = [{
  value: 1,
  label: "启用"
}, {
  value: 2,
  label: "禁用"
}]

// 年份
let startYear = 2000
let endYear = new Date().getFullYear()
let yearList = []
for (let i = endYear; i >= startYear; i--) {
  yearList.push(String(i))
}
export const years = yearList

export const imageSize = [{
  label: "学术委员会",
  width: "178",
  height: "250",
  image: "img1"
},
{
  label: "专家学者",
  width: "178",
  height: "250",
  image: "img1"
},
{
  label: "最新动态",
  width: "256",
  height: "172",
  image: "img2"
},
{
  label: "通知公告",
  width: "256",
  height: "172",
  image: "img2"
},
{
  label: "活动预告",
  width: "210",
  height: "280",
  image: "img3"
},
{
  label: "前沿观点",
  width: "256",
  height: "172",
  image: "img2"
},
{
  label: "学术著作",
  width: "210",
  height: "280",
  image: "img3"
},
{
  label: "期刊论文",
  width: "210",
  height: "280",
  image: "img3"
},
{
  label: "课题项目",
  width: "210",
  height: "280",
  image: "img3"
},
{
  label: "荣誉奖项",
  width: "210",
  height: "280",
  image: "img3"
},
{
  label: "博士后培养",
  width: "256",
  height: "172",
  image: "img2"
},
{
  label: "博士生培养",
  width: "256",
  height: "172",
  image: "img2"
},
{
  label: "硕士生培养",
  width: "256",
  height: "172",
  image: "img2"
},
{
  label: "开设课程",
  width: "256",
  height: "172",
  image: "img2"
},
{
  label: "教育部重大课题大事记",
  width: "256",
  height: "172",
  image: "img2"
},
{
  label: "新闻报道",
  width: "256",
  height: "172",
  image: "img2"
},
{
  label: "项目成果",
  width: "210",
  height: "280",
  image: "img3"
},
]